import { hasAuthSession } from '@/utils/auth-token';
import { resolveDepositGeoSession } from '@/utils/deposit-geo-session';
import { resolveIsChinaMainlandUser } from '@/utils/china-mainland-region';
import { resolveIsUsFiatRestricted } from '@/utils/deposit-us-fiat-guard';
import { resolveIsUsPayIpAllowed } from '@/utils/deposit-us-pay-guard';
import { resolveIsBrazilPayIpAllowed } from '@/utils/deposit-brazil-pay-guard';
import { resolveIsIndiaPayIpAllowed } from '@/utils/deposit-india-pay-guard';
import { resolveIsMexicoPayIpAllowed } from '@/utils/deposit-mexico-pay-guard';
import { resolveIsVietnamPayIpAllowed } from '@/utils/deposit-vietnam-pay-guard';
import { resolveIsIndonesiaPayIpAllowed } from '@/utils/deposit-indonesia-pay-guard';
import { useDepositOptionsStore } from '@/stores/depositOptions';
import { useFiatDepositStore } from '@/stores/fiatDeposit';
import { useTopPayDepositStore } from '@/stores/toppayDeposit';

function isFiatDepositEnabled() {
  return (
    hasAuthSession() &&
    String(process.env.VUE_APP_ENABLE_FIAT_DEPOSIT ?? 'true').toLowerCase() !== 'false'
  );
}

/** 登录 / 刷新后预拉充值选项，打开弹窗时直接读 store */
export async function prefetchDepositSession() {
  if (!hasAuthSession()) return;

  // 预拉弹窗 chunk，避免首次点充值空白一瞬
  void import('@/components/DepositDialog.vue');
  // 预探测大陆出口，打开充值时可同步命中拦截
  void resolveIsChinaMainlandUser();

  const [{ countryCode }, usFiatBlocked] = await Promise.all([
    resolveDepositGeoSession(),
    resolveIsUsFiatRestricted().catch(() => false),
  ]);
  // 复用上面的出口 IP 缓存；fail-closed，探测失败不展示落地扫码
  void resolveIsUsPayIpAllowed().catch(() => false);
  void resolveIsVietnamPayIpAllowed().catch(() => false);
  void resolveIsBrazilPayIpAllowed().catch(() => false);
  void resolveIsMexicoPayIpAllowed().catch(() => false);
  void resolveIsIndiaPayIpAllowed().catch(() => false);
  void resolveIsIndonesiaPayIpAllowed().catch(() => false);

  const tasks = [useDepositOptionsStore().prefetchForSession({ countryCode })];
  if (isFiatDepositEnabled() && !usFiatBlocked) {
    tasks.push(useFiatDepositStore().prefetchForSession());
    tasks.push(useTopPayDepositStore().loadSupported());
  } else if (isFiatDepositEnabled() && usFiatBlocked) {
    // 美国出口 IP：仍预拉 TopPay supported 以判断 NowPay US 是否可用
    tasks.push(useTopPayDepositStore().loadSupported());
  }

  await Promise.allSettled(tasks);
}
